(function(root){
 'use strict';
 const ID='196445405510',LANGS=['de','en','fr','nl'],PREVIEW=/^[a-z0-9]+-76547719494\.shopifypreview\.com$/i;
 const domains={'prometheus-bikes.com':null,'www.prometheus-bikes.com':null,'en.prometheus-bikes.com':'en','fr.prometheus-bikes.com':'fr','nl.prometheus-bikes.com':'nl','es.prometheus-bikes.com':'es','it.prometheus-bikes.com':'it','pl.prometheus-bikes.com':'pl','sv.prometheus-bikes.com':'sv'};
 const normalize=v=>typeof v==='string'?v.toLowerCase().split('-')[0]:null;
 const usable=v=>LANGS.includes(normalize(v))?normalize(v):'de';
 const allowed=c=>String(c.themeId)===ID&&['unpublished','main'].includes(c.themeRole);
 const previewAllowed=c=>String(c.themeId)===ID&&c.themeRole==='unpublished'&&PREVIEW.test(String(c.hostname||''));
 const memoryKey='pb:preview-language:'+ID+':v1';
 function createPreviewMemory(storage){
  return {
   read(c){if(!previewAllowed(c))return null;try{const value=storage().getItem(memoryKey);return LANGS.includes(value)?value:null;}catch{return null;}},
   choose(c,value){if(!previewAllowed(c)||!LANGS.includes(value))return false;try{storage().setItem(memoryKey,value);return true;}catch{return false;}}
  };
 }
 function resolve(c){
  if(!allowed(c))return 'de';
  const host=String(c.hostname||'').toLowerCase();
  const preview=previewAllowed(c);
  if(!preview&&!Object.prototype.hasOwnProperty.call(domains,host))return 'de';
  if(preview){
   const params=new URLSearchParams(c.search||'');
   if(params.get('pb_preview_nav')==='1'&&LANGS.includes(params.get('pb_preview_lang')))return params.get('pb_preview_lang');
   if(LANGS.includes(c.previewLanguage))return c.previewLanguage;
  }
  if(domains[host])return usable(domains[host]);
  for(const candidate of [c.providerLanguage,c.widgetLanguage,c.documentLanguage,c.requestLocale]){
   if(candidate)return usable(candidate);
  }
  return 'de';
 }
 const api={allowed,previewAllowed,createPreviewMemory,resolve};
 if(typeof module!=='undefined'&&module.exports){module.exports=api;return;}
 if(root.PBStorefrontLanguage)return;
 const doc=root.document;
 function context(){
  let config;try{config=JSON.parse(doc.querySelector('[data-pb-language-assets]')?.textContent||'null');}catch{}
  const c={themeId:config?.theme_id,themeRole:config?.theme_role,requestLocale:config?.request_locale,hostname:root.location.hostname,search:root.location.search,widgetLanguage:doc.querySelector('.weglot_switcher.country-selector [role="combobox"][data-l]')?.getAttribute('data-l'),documentLanguage:doc.documentElement.lang};
  try{if(root.Weglot?.initialized||(previewAllowed(c)&&c.widgetLanguage))c.providerLanguage=root.Weglot?.getCurrentLang?.();}catch{}
  return c;
 }
 const memory=createPreviewMemory(()=>root.sessionStorage);
 api.current=()=>{const c=context();return resolve({...c,previewLanguage:memory.read(c)});};root.PBStorefrontLanguage=api;root.pbDraftLanguage=api.current;
 let previous,providerBound=false,pending=false;
 let restoreAttempt=null,restoringWidget=false;
 function previewStatus(c,value){if(previewAllowed(c))doc.querySelector('[data-pb-language-assets]')?.setAttribute?.('data-pb-preview-language-status',value);}
 function restorePreview(){
  const c=context(),saved=memory.read(c);if(!saved){previewStatus(c,'no-choice');return;}if((!root.Weglot?.initialized&&!c.widgetLanguage)||typeof root.Weglot?.switchTo!=='function'){previewStatus(c,'waiting-provider');return;}
  const params=new URLSearchParams(c.search||'');if(params.get('pb_preview_nav')==='1'&&LANGS.includes(params.get('pb_preview_lang')))return;
  if(c.providerLanguage===saved&&c.widgetLanguage===saved){restoreAttempt=null;previewStatus(c,'matched:'+saved);return;}
  if(c.providerLanguage===saved&&c.widgetLanguage!==saved){
   const link=doc.querySelector('.weglot_switcher.country-selector a[id^="weglot-language-"][lang="'+saved+'"]');
   if(!link||restoreAttempt==='widget:'+saved)return;
   restoreAttempt='widget:'+saved;previewStatus(c,'native-switcher:'+saved);
   // Reuse the installed switcher handler, while forbidding its production URL navigation in draft restoration.
   link.addEventListener('click',event=>event.preventDefault(),{capture:true,once:true});
   restoringWidget=true;try{link.click();}finally{restoringWidget=false;}return;
  }
  if(restoreAttempt===saved)return;restoreAttempt=saved;
  try{previewStatus(c,'requested:'+saved);root.Weglot.switchTo(saved);}catch(error){previewStatus(c,'provider-error:'+String(error?.message||error));}
 }
 function rememberPreviewChoice(event){
  if(restoringWidget)return;
  if(event.button!==0||event.ctrlKey||event.metaKey||event.altKey||event.shiftKey)return;
  const link=event.target.closest?.('.weglot_switcher.country-selector a[href]');if(!link)return;
  let host;try{host=new URL(link.href,doc.baseURI).hostname;}catch{return;}
  const chosen=host==='prometheus-bikes.com'||host==='www.prometheus-bikes.com'?'de':domains[host];
  if(memory.choose(context(),chosen)){event.preventDefault();restoreAttempt=null;schedule();}
 }
 function publish(){const language=api.current();if(language===previous)return;previous=language;doc.dispatchEvent(new root.CustomEvent('pb:locale-change',{detail:{language}}));}
 function bind(){if(providerBound||typeof root.Weglot?.on!=='function')return;providerBound=true;for(const event of ['initialized','switchersReady','languageChanged'])root.Weglot.on(event,schedule);}
 function schedule(){if(pending)return;pending=true;queueMicrotask(()=>{pending=false;bind();restorePreview();publish();});}
 function start(){new root.MutationObserver(schedule).observe(doc.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['lang','data-l']});if(previewAllowed(context()))doc.addEventListener('click',rememberPreviewChoice,true);bind();restorePreview();publish();}
 root.addEventListener('load',schedule);root.addEventListener('popstate',schedule);
 if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',start,{once:true});else start();
})(typeof window==='undefined'?globalThis:window);
